
import { Directive, Input, Renderer2, ElementRef, SimpleChanges, OnChanges, HostListener, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { EnvSetting } from '../utils/env-setting';
import { GlobalSetting } from '../common-services/global-setting.service';

@Directive({
    selector: 'img[af-brand-logo]'
})
export class AfBrandLogoDirective implements OnChanges, OnInit {
    @Input('data-code') imgCode: string;
    @Input('data-type') imgType: string | null = null;
    @Input('data-src') imgSrc: string | null = null;
    @Input('data-fallback') fallback: string | null = null;

    private readonly _noImage = '../../../../assets/no-image-icon.png';
    private readonly _loading = '/assets/images/loading.svg';
    constructor(private readonly http: HttpClient,
        private readonly globalSetting: GlobalSetting,
        private readonly elementRef: ElementRef,
        private readonly renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document) {
    }
    ngOnInit(): void {
        this.elementRef.nativeElement.src = this._loading;
        this.renderer.setAttribute(this.elementRef.nativeElement, 'img-code', this.imgCode?.toUpperCase());
        this.loadImage();
    }

    @HostListener('error')
    loadFallback() {
        this.elementRef.nativeElement.src = this.fallback ?? this._noImage;
    }

    ngOnChanges(_changes: SimpleChanges): void {
        this.loadImage();
    }

    loadImage() {
        const element = this.elementRef.nativeElement;
        if (!element) {
            return;
        }
        if (this.imgType?.toUpperCase() == "BRAND") {
            const brandCode = this.imgCode?.toUpperCase();
            const existImg = this.globalSetting.brandLogos.find(x => x.brandCode == brandCode);
            if (!brandCode) {
                element.src = this._noImage;
            }
            else if (existImg?.imgData) {
                this.reloadBrand(brandCode, existImg.imgData);
            }
            else if (brandCode && !existImg) {
                this.globalSetting.brandLogos.push({ brandCode: brandCode, imgData: '' });
                let headers = new HttpHeaders();
                headers = headers.set('Accept', 'application/json')
                    .set('Content-Type', 'application/json');
                this.http.get(`${EnvSetting.BRAND_API_URL}/${brandCode}`, { headers }).subscribe((res: any) => {
                    if (res) {
                        this.globalSetting.brandLogos.filter(x => x.brandCode == brandCode).forEach(el => {
                            el.imgData = res;
                        });
                        this.reloadBrand(brandCode, res);
                    }
                    else{
                        this.reloadBrand(brandCode, this._noImage);              7
                    }
                },(_err)=>{
                    this.reloadBrand(brandCode, this._noImage);
                });
            }
            else{
                this.reloadBrand(brandCode, this._noImage);
            }
        }
        else {
            this.renderer.setAttribute(element, 'src', this.imgSrc ?? this._noImage);
        }
    }
    reloadBrand(brandCode: string, imgData: string){
        const brands = this.document.querySelectorAll(`[img-code="${brandCode}"]`);
        brands.forEach((img) => {
            this.renderer.setAttribute(img, 'src', imgData);
        });
    }
}